import {Component} from '@angular/core';

@Component({
  selector: 'aw-shops',
  templateUrl: './shops-container.component.html',
  styleUrls: ['./shops-container.component.scss']
})
export class ShopsContainerComponent {
}
